import React, { useMemo, useState } from 'react';
import { Mail, Building2, MessageSquare, Search, Lock } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import './AdminPages.css';

export default function ContactsPage() {
  const { data } = useApp();
  const { can } = useAuth();
  const canView = can('canViewContacts');
  const [search, setSearch] = useState('');

  if (!canView) {
    return (
      <div className="admin-page">
        <div className="page-header"><div><h1 className="page-title">Contacts</h1></div></div>
        <div className="perm-denied">
          <div className="perm-denied-icon"><Lock size={26} style={{ color:'var(--text-dim)' }}/></div>
          <p style={{ fontWeight:700 }}>Access Restricted</p>
          <p style={{ color:'var(--text-muted)',fontSize:'0.875rem' }}>Contacts are restricted to founders, administrators, and HR.</p>
        </div>
      </div>
    );
  }

  const rows = useMemo(() => {
    const q = search.trim().toLowerCase();
    const list = data.contacts || [];
    if (!q) return list;
    return list.filter((c) =>
      [c.name, c.email, c.company, c.service, c.message].some((v) =>
        String(v || '').toLowerCase().includes(q)
      )
    );
  }, [data.contacts, search]);

  return (
    <div className="admin-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Contacts</h1>
          <p className="page-subtitle">{rows.length} website enquiries captured from the public contact form</p>
        </div>
      </div>

      <div className="filter-bar">
        <div className="search-box">
          <Search size={15}/>
          <input className="search-input" placeholder="Search contacts..." value={search} onChange={(e)=>setSearch(e.target.value)}/>
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {rows.map((contact) => (
          <div key={contact.id} className="card" style={{ padding:18 }}>
            <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:16 }}>
              <div style={{ flex:1 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8, flexWrap:'wrap' }}>
                  <p style={{ fontWeight:700 }}>{contact.name}</p>
                  <span className="badge badge-info">{contact.service || 'General enquiry'}</span>
                </div>
                <div style={{ display:'flex', gap:14, flexWrap:'wrap', fontSize:'0.78rem', color:'var(--text-muted)', marginBottom:10 }}>
                  <span style={{ display:'flex', alignItems:'center', gap:5 }}><Mail size={12}/>{contact.email}</span>
                  <span style={{ display:'flex', alignItems:'center', gap:5 }}><Building2 size={12}/>{contact.company || 'No company listed'}</span>
                </div>
                <div style={{ display:'flex', alignItems:'flex-start', gap:8 }}>
                  <MessageSquare size={14} style={{ marginTop:2, color:'var(--secondary-color)' }}/>
                  <p style={{ fontSize:'0.84rem', lineHeight:1.6, color:'var(--text-muted)' }}>{contact.message}</p>
                </div>
              </div>
              <div style={{ fontSize:'0.75rem', color:'var(--text-dim)', whiteSpace:'nowrap' }}>
                {contact.createdAt?.seconds
                  ? new Date(contact.createdAt.seconds * 1000).toLocaleString('en-ZA')
                  : 'Just now'}
              </div>
            </div>
          </div>
        ))}
        {rows.length === 0 && (
          <div className="card" style={{ padding:32, textAlign:'center', color:'var(--text-dim)' }}>
            No contacts found.
          </div>
        )}
      </div>
    </div>
  );
}
